import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const DashboardConfig = () => {
  const [product, setProduct] = useState("");
  const [productList, setProductList] = useState([]);
  const navigate = useNavigate();

  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/onboarded-products`);
        setProductList(response.data);
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };

    fetchProducts();
  }, [BASE_URL]);

  const handleConfigure = () => {
    if (product) {
      const newTabUrl = `/product-report/${product}`;
      window.open(newTabUrl, "_blank"); // opens in a new tab
    }
  };

  return (
    // Full-screen center container
    <div className=" flex mt-[4rem] items-center justify-center p-4">
      {/* Card container */}
      <div className="w-96 sm:w-[450px] md:w-[500px] bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden  pt-4">
        {/* Top small rounded header band */}
        <div className="bg-[#bb1ccc] px-6 py-3 ">
          <h2 className="text-center text-2xl  font-semibold text-white">
            Dashboard Configuration
          </h2>
          <p className="text-center text-[14px] text-white mt-1">
            Configure your dashboard settings to get started
          </p>
        </div>

        {/* Content area */}
        <div className="px-6 py-6">
          <label
            htmlFor="product"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Product Name
          </label>

          <FormControl fullWidth className="mb-4">
            <InputLabel id="product-label">Product Name</InputLabel>
            <Select
              labelId="product-label"
              id="product"
              value={product}
              label="Product Name"
              onChange={(e) => {
                const selectedValue = e.target.value;
                setProduct(selectedValue);
                const selectedProduct = productList.find(
                  (item) => item.productId === selectedValue
                );
                if (selectedProduct) {
                  localStorage.setItem(
                    "selectedProductName",
                    selectedProduct.productName
                  );
                }
              }}
              sx={{
                textAlign: "left",
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200,
                  },
                },
              }}
            >
              <MenuItem value="">Select a product...</MenuItem>
              {productList.map((item) => (
                <MenuItem key={item.productId} value={item.productId}>
                  {item.productName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <button
            className={`w-full py-2.5 rounded-md text-sm font-medium shadow-sm focus:outline-none transition ${
              product
                ? "bg-[#bb1ccc]  text-white"
                : "bg-[#bb1ccc] text-white cursor-not-allowed opacity-60"
            }`}
            onClick={handleConfigure}
            disabled={!product}
          >
            Configure Dashboards
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardConfig;
